import React from 'react'

const PaycodeDistribution = () => {
    return (
        <>PaycodeDistribution mobile</>
    )
}

export { PaycodeDistribution }